// import icons
import { FaYoutube, FaInstagram, FaGithub, FaBars } from "react-icons/fa";
import { BsChatDotsFill } from "react-icons/bs";
import { MdRecentActors, MdVpnKey } from "react-icons/md";
import { ReactComponent as LogoWhite } from "./assets/svg/logo.svg";

import authBg from "./assets/jpg/auth-bg.jpg";
import homeBanner from "./assets/jpg/home-banner.jpg";
import noAvatar from "./assets/jpg/no-avatar.jpg";
import logo from "./assets/png/LogoCatelli_Sin_Fondo.png";
import avatar01 from "./assets/png/avatar_01.png";
import avatar02 from "./assets/png/avatar_02.png";
import avatar03 from "./assets/png/avatar_03.png";
import avatar04 from "./assets/png/avatar_04.png";
import avatar05 from "./assets/png/avatar_05.png";
import avatar06 from "./assets/png/avatar_06.png";
import pdf from "./assets/png/pdf.png";
import doc from "./assets/png/doc.png";
import file from "./assets/png/file.png";
import fileRinbow from "./assets/png/file_r.png";
import fileRojo from "./assets/png/file_red.png";
import rrhh from "./assets/png/rrhh1.png";
import background_home from "./assets/png/catelli_frontal.png";
import touchpc from "./assets/jpg/touchpc.jpg";
import retropc from "./assets/jpg/retropc.jpg";
import comprobado from "./assets/png/cheque.png";

// import images
import AboutImg from "./assets/img/about.png";
import Feature1Img from "./assets/img/features/feature1.png";
import Feature2Img from "./assets/img/features/feature2.png";
import Feature3Img from "./assets/img/features/feature3.png";
import Feature4Img from "./assets/img/features/feature4.png";
import Avatar1Img from "./assets/img/testimonials/avatar1.png";
import Avatar2Img from "./assets/img/testimonials/avatar2.png";
import Avatar3Img from "./assets/img/testimonials/avatar3.png";
import LogoV2 from "./assets/img/logo-v2.png";
// import HeroImage from "./assets/img/hero-img.png";
import Feature1BgImg from "./assets/img/features/feature1_bg.png";
import Feature2BgImg from "./assets/img/features/feature2_bg.png";
import Feature3BgImg from "./assets/img/features/feature3_bg.png";
import Feature4BgImg from "./assets/img/features/feature4_bg.png";

import BgPage from "./assets/png/catelli_frontal.png";
import GestionHumana from "./assets/png/rrhh1_sm.png";
import Secciones from "./assets/png/header_seccion.png";

// Imagenes de las Secciones
import SantoDomingoNorte from "./assets/jpg/sdn.jpg";
import SantoDomingoEste from "./assets/jpg/sde1.jpg";
import MontePlata from "./assets/jpg/MONTE-PLATA.jpeg";

//Servicios
import logistica from "./assets/jpg/logistica.jpeg";
import servicioCliente from "./assets/jpg/decliente.jpg";
import ejecucion from "./assets/jpg/herramienta_de_trade_marketing.png";
import sventas from "./assets/jpg/ventas.jpg";
import sventas1 from "./assets/png/team_sales.png";
//Fondos Servicios
import imageIGb from "./assets/png/feature2_bg.png";
import image2Gb from "./assets/png/feature4_bg.png";

// Clientes
import colmado from "./assets/png/storefront_illustration_2.png";
import market from "./assets/png/market.png";

const Icon = {
  LogoWhite,
};

const image = {
  authBg,
  homeBanner,
  noAvatar,
  logo,
  avatar01,
  avatar02,
  avatar03,
  avatar04,
  avatar05,
  avatar06,
  rrhh,
  background_home,
  pdf,
  doc,
  file,
  fileRinbow,
  fileRojo,
  comprobado,
  touchpc,
  retropc,
};

const cobertura = {
  title: "Cobertura",
  subtitle:
    "Inversiones Catelli, tiene la Distribución en las zonas de Santo Domingo Norte, Santo Domingo Este, y tambien una alta distribucion en la zona de Monte Plata, Yamasa, Bayaguana, Guerra.",
  list: [
    { image: SantoDomingoNorte, title: "Santo Domingo Norte", delay: "400" },
    { image: SantoDomingoEste, title: "Santo Domingo Este", delay: "700" },
    { image: MontePlata, title: "Monte Plata", delay: "1000" },
  ],
};

const servicios = {
  title: "Nuestros Servicios",
  subtitle:
    "Inversiones Catelli, tenemos mas de 15 años ofreciendo un servicio excepcional.",
  list: [
    {
      image: logistica,
      title: "Logigista",
      imageGb: imageIGb,
      descripcion:
        "Contamos con 29 camiones propios y un equipo de reparto compuesto por 36 repartidores y ayudantes.",
      delay: "400",
    },
    {
      image: servicioCliente,
      title: "Servicios al Cliente",
      imageGb: imageIGb,
      descripcion:
        "Entendemos que nuestros clientes son el motor del negocio, por eso nos esforzamos en asegurar un alto servicio al cliente.",
      delay: "700",
    },
    {
      image: ejecucion,
      title: "Ejecucion y Visibilidad",
      imageGb: imageIGb,
      descripcion:
        "Contamos con un equipo de mercaderistas enfocados en asegurar la visibilidad de los productos que distribuimos.",
      delay: "1000",
    },
    {
      image: sventas1,
      title: "Ventas",
      imageGb: imageIGb,
      descripcion:
        "Contamos con un equipo de ventas motivado compuesto por 2 supervisores y 27 vendedores.",
      delay: "1300",
    },
  ],
};

const clientes = {
  title: "Nuestros Clientes",
  subtitle: "Entendemos que nuestros clientes son el motor del negocio.",
  list: [
    {
      image: colmado,
      title: "Colmado",
      imageGb: image2Gb,
      descripcion:
        "Abarcamos alrededor de 8,000+ colmados en la zona de Santo Domingo Norte, Santo Domingo Este y la Zona Oriental.",
      delay: "400",
    },
    {
      image: market,
      title: "Supermercado",
      imageGb: image2Gb,
      descripcion:
        "Brindamos servicio a 150+ Supermercado en la zona de Santo Domingo Norte, Santo Domingo Este y la Zona Oriental.",
      delay: "700",
    },
    {
      image: ejecucion,
      title: "Mayorista",
      imageGb: image2Gb,
      descripcion:
        "Brindamos servicio a 200+ Mayorista en la zona de Santo Domingo Norte, Santo Domingo Este y la Zona Oriental.",
      delay: "1000",
    },
    {
      image: sventas,
      title: "Otros",
      imageGb: image2Gb,
      descripcion:
        "Manejamos otros tipos de negocios, como farmacia, cafeteria, ferreteria, etc.",
      delay: "1300",
    },
  ],
};

const footerData = {
  logo: logo,
  address:
    "Inversiones Catelli, S.R.L, Av. Hermanas Mirabal #39, Villa Mella, Santo Domingo",
  email: "info@catelli.net",
  phone: "809 332 9003",
  list1: [
    {
      name: "Sobre Nosotros",
      href: "/nosotros",
    },
    {
      name: "Gestion Humana",
      href: "/recursohumano",
    },
    {
      name: "Nuestros Socios",
      href: "#",
    },
    {
      name: "Productos",
      href: "#",
    },
  ],
  list2: [
    {
      name: "Contacto",
      href: "/contacto",
    },
    // {
    //   name: "Sign Up",
    //   href: "#",
    // },
    // {
    //   name: "Guide",
    //   href: "#",
    // },
    // {
    //   name: "Reports",
    //   href: "#",
    // },
    {
      name: "Q & A",
      href: "#",
    },
  ],
  socialList: [
    {
      icon: <FaYoutube />,
      href: "#",
    },
    {
      icon: <FaInstagram />,
      href: "#",
    },
    {
      icon: <FaGithub />,
      href: "#",
    },
  ],
};

const copyrightData = {
  text: "© CIGUA DR, 2023. All rights reserved.",
  icon: <BsChatDotsFill />,
};

const navLink = [
  {
    id: 0,
    title: "Dashboard",
    icon: <FaBars size={"2em"} />,
    url: "/admin",
  },
  {
    id: 1,
    title: "Gestion Humana",
    icon: <MdRecentActors size={"2em"} />,
    url: "/admin/gestionhumana",
  },
  // {
  //   id: 2,
  //   title: "Contactos",
  //   icon: <MdSupervisedUserCircle size={"2em"} />,
  //   url: "/admin/users",
  // },
  // {
  //   id: 3,
  //   title: "Menu",
  //   icon: <MdSupervisedUserCircle size={"2em"} />,
  //   url: "/admin/users",
  // },
  {
    id: 4,
    title: "Usuarios",
    icon: <MdVpnKey size={"2em"} />,
    url: "/admin/users",
  },
];

const navigationData = [
  {
    name: "Deliver",
    href: "#",
  },
  {
    name: "About",
    href: "#",
  },
  {
    name: "Features",
    href: "#",
  },
  {
    name: "Signup",
    href: "#",
  },
];

const heroData = {
  title: `INVERSIONES CATELLI`,
  subtitle: "¡Lider en Distribucción!",
  btnText: "",
  image: BgPage,
};

const hero = [
  {
    seccion: "home",
    title: "INVERSIONES CATELLI",
    subtitle: "¡Lider en Distribucción!",
    btnText: "",
    image: BgPage,
    url: "",
  },
  {
    seccion: "recursohumano",
    title: "GESTION HUMANA",
    subtitle: "Somos una familia",
    btnText: "¿Quiere ser parte de nuestra familia?",
    image: GestionHumana,
    url: "/recursohumano/formulario",
  },
  {
    seccion: "formulario",
    title: "Se parte de nosotros",
    subtitle: "",
    btnText: "",
    image: Secciones,
    url: "",
  },
  {
    seccion: "contact",
    title: "Contactanos",
    subtitle: "",
    btnText: "",
    image: Secciones,
    url: "",
  },
  {
    seccion: "sobrenosotros",
    title: "Sobre Nosotros",
    subtitle: "",
    btnText: "",
    image: Secciones,
    url: "",
  },
];

const aboutData = {
  image: AboutImg,
  title: "Find Out A Little More About Us",
  subtitle:
    "We are a company dedicated to the distribution of products by delivery to your home or to the place where you are, with the best quality of delivery.",
};

const featuresData = {
  title: "Some Services We Offer",
  subtitle:
    "With our app you can view the route of your order, from our local headquarters to the place where you are. Look for the app now!",
  list: [
    {
      image: Feature1Img,
      bgImage: Feature1BgImg,
      title: "Payment Done",
      description: "Pay with a Visa or PayPal card and without much ado",
      linkText: "Learn more",
      delay: "400",
    },
    {
      image: Feature2Img,
      bgImage: Feature2BgImg,
      title: "Find Your Product",
      description: "We offer sale of products through the Internet..",
      linkText: "Learn more",
      delay: "700",
    },
    {
      image: Feature3Img,
      bgImage: Feature3BgImg,
      title: "Print Out",
      description:
        "Print out service gives you convenience if someday you need print data, just edit it all and just print it.",
      linkText: "Learn more",
      delay: "1000",
    },
    {
      image: Feature4Img,
      bgImage: Feature4BgImg,
      title: "Product Received",
      description: "In our app you can see the delay time of your order...",
      linkText: "Learn more",
      delay: "1300",
    },
  ],
};

const testimonialsData = [
  {
    image: Avatar1Img,
    name: "Serena",
    web: "rena.com",
    message:
      "Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.",
    delay: "300",
  },
  {
    image: Avatar2Img,
    name: "Natalia",
    web: "nataliya.com",
    message:
      "Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.",
    delay: "600",
  },
  {
    image: Avatar3Img,
    name: "Vebin",
    web: "vebin.com",
    message:
      "Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.",
    delay: "900",
  },
];

const ctaData = {
  title: "Contact Us From Here",
  subtitle: "Get limited 1 week free try our features!",
  btnText1: "Learn more",
  btnText2: "Request Demo",
};

const footerData2 = {
  logo: LogoV2,
  address: "Product Texas, 234 Bokki Avenue Street BMW 99388",
  email: "info@producttexas.project",
  phone: "1-232-7788 (Main)",
  list1: [
    {
      name: "Profile",
      href: "#",
    },
    {
      name: "Features",
      href: "#",
    },
    {
      name: "Careers",
      href: "#",
    },
    {
      name: "DW News",
      href: "#",
    },
  ],
  list2: [
    {
      name: "Support",
      href: "#",
    },
    {
      name: "Sign Up",
      href: "#",
    },
    {
      name: "Guide",
      href: "#",
    },
    {
      name: "Reports",
      href: "#",
    },
    {
      name: "Q & A",
      href: "#",
    },
  ],
  socialList: [
    {
      icon: <FaYoutube />,
      href: "#",
    },
    {
      icon: <FaInstagram />,
      href: "#",
    },
    {
      icon: <FaGithub />,
      href: "#",
    },
  ],
};

const areaInteres = [
  { key: "1", value: "finanzas", text: "Finanzas" },
  { key: "2", value: "cuentas-por-cobrar", text: "Cuentas por Cobrar" },
  { key: "3", value: "gestion-humana", text: "Gestion Humana" },
  {
    key: "4",
    value: "ejecucion-mercaderistas",
    text: "Ejecucion - Mercaderistas",
  },
  {
    key: "5",
    value: "ventas-ejecutivo-supervisor",
    text: "Ventas - (Ejecutivo de ventas y/o Supervisor)",
  },
  { key: "6", value: "logistica", text: "Logistica" },
  {
    key: "7",
    value: "tecnologia-informacion",
    text: "Tecnologia de Informacion",
  },
  { key: "8", value: "almacen", text: "Almacen" },
  { key: "9", value: "comercial-gerente", text: "Comercial (Gerente)" },
  { key: "10", value: "mensajerias", text: "Mensajerias" },
  { key: "11", value: "conserge", text: "Conserge" },
  { key: "12", value: "seguridad", text: "Seguridad" },
  { key: "13", value: "mecanico", text: "Mercanico" },
  { key: "14", value: "*", text: "Todos" },
];

const salarios = [
  { key: "1", value: "500-10000", text: "500-10000" },
  { key: "2", value: "500-10000", text: "11000-20000" },
  { key: "3", value: "21000-30000", text: "21000-30000" },
  { key: "4", value: "31000-40000", text: "31000-40000" },
  { key: "5", value: "41000-50000", text: "41000-50000" },
  { key: "6", value: "51000-60000", text: "51000-60000" },
  { key: "7", value: "61000-70000", text: "61000-70000" },
  { key: "8", value: "71000-80000", text: "71000-80000" },
  { key: "9", value: "81000-90000", text: "81000-90000" },
  { key: "10", value: "100000+", text: "100000+" },
];

const personalACargo = [
  { key: "1", value: "1", text: "1" },
  { key: "2", value: "2", text: "2" },
  { key: "3", value: "3", text: "3" },
  { key: "4", value: "4", text: "4" },
  { key: "5", value: "5-10", text: "5-10" },
  { key: "6", value: "11-20+", text: "11-20+" },
  { key: "7", value: "100+", text: "100+" },
];

const herrramientasOptions = [
  { value: "world", label: "World" },
  { value: "excel", label: "Excel" },
  { value: "powerpoint", label: "PowerPoint" },
  { value: "powerbi", label: "Power BI" },
  { value: "project", label: "MS Project" },
  { value: "ninguna", label: "Ninguna" },
];

const estadoCivil = [
  { key: "s", text: "Soltero", value: "soltero" },
  { key: "c", text: "Casado", value: "casado" },
  { key: "u", text: "Union Libre", value: "union_libre" },
  { key: "v", text: "Viudo", value: "viudo" },
];
const genderOptions = [
  { key: "m", text: "Masculino", value: "Masculino" },
  { key: "f", text: "Femenino", value: "Femenino" },
];

const siNo = [
  { key: "s", text: "Si", value: "si" },
  { key: "n", text: "No", value: "no" },
];

const licenciaCategoria = [
  { key: "0", text: "No", value: "no" },
  { key: "2", text: "2", value: "2" },
  { key: "3", text: "3", value: "3" },
  { key: "4", text: "4", value: "4" },
  { key: "5", text: "5", value: "5" },
];

export {
  Icon,
  image,
  cobertura,
  servicios,
  clientes,
  footerData,
  copyrightData,
  navLink,
  navigationData,
  heroData,
  hero,
  aboutData,
  featuresData,
  testimonialsData,
  ctaData,
  footerData2,
  areaInteres,
  herrramientasOptions,
  estadoCivil,
  genderOptions,
  licenciaCategoria,
  siNo,
  salarios,
  personalACargo,
};
